'use strict';

function SendCollectionsController(
    $scope,
    $mdDialog,
    $filter,
    collections,
    total
) {
    'ngInject';

    $scope.collections = collections;
    $scope.total = total;

    $scope.cancel = function() {
        $mdDialog.cancel();nnn
    };

    $scope.save = function() {
        $mdDialog.hide({
            amount: $scope.manualAmount,
            comments: $scope.comments
        });
    }

    $scope.onManualAmountChange = function() {
        if ($scope.manualAmount != $scope.total) {
            let difference = $scope.total - $scope.manualAmount;
            if (!isNaN(difference)) {
                $scope.warningMessage = `Serán transferidos ${$filter('formatMoney')($scope.manualAmount)} a caja general. Se generará un ajuste de caja en tesorería por ${$filter('formatMoney')(difference)}`;
            } else {
                $scope.warningMessage = null;
            }
        } else {
            $scope.warningMessage = null;
        }
    }
}

export default SendCollectionsController;
